<template>
    <div class="product-card">
        <div v-if="props.product != null" class="product-container">
            <div class="d-flex justify-content-between">
                <div class="product-image">
                    <a :href="productUrl"><img class="img-fluid" :src="productMediaUrl" alt="" srcset=""></a>
                </div>
                <div class="d-flex flex-column flex-grow-1 product-data-container">
                    <div class="product-title"><a :href="productUrl">{{ props.product.name }}</a></div>
                    <div class="product-price-data">
                        <div>
                            <div style="display: inline;">定價：NT$ <div
                                    style="text-decoration: line-through; display: inline;">{{
                                        props.product.price.listPrice }}</div>
                            </div>
                        </div>
                        <div>
                            <div style="display: inline;">優惠價：<div style="display: inline; color: #FF057D;">{{
                                Math.ceil((props.product.price.salePrice /
                                    props.product.price.listPrice) * 100) }}</div> 折，NT$ <div
                                    style="display: inline; color: #FF057D;">{{
                                        props.product.price.salePrice }}</div>
                            </div>
                        </div>
                    </div>
                    <a :href="addToCartUrl" type="button" class="btn add-to-cart-button align-self-end">
                        <div>
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M32.0095 28.46L33.7095 21C33.7595 20.78 33.7095 20.54 33.5595 20.36C33.4195 20.18 33.1995 20.08 32.9795 20.08C30.7595 20.09 28.5495 20.09 26.3295 20.08C24.2895 20.08 22.2495 20.07 20.2095 20.08L19.3295 16.32C19.2495 15.98 18.9495 15.74 18.5995 15.74L15.0195 15.73C14.5995 15.75 14.2695 16.06 14.2695 16.47C14.2695 16.88 14.5995 17.22 15.0195 17.22L17.9995 17.24L20.6395 28.47C20.7195 28.81 21.0195 29.05 21.3695 29.05H22.2195C21.3295 29.11 20.6195 29.84 20.6195 30.75C20.6195 31.69 21.3895 32.46 22.3295 32.46C23.2695 32.46 24.0395 31.69 24.0395 30.75C24.0395 29.84 23.3295 29.11 22.4395 29.05H30.0595C29.1695 29.11 28.4595 29.84 28.4595 30.75C28.4595 31.69 29.2295 32.46 30.1695 32.46C31.1095 32.46 31.8795 31.69 31.8795 30.75C31.8795 29.84 31.1695 29.11 30.2795 29.05H31.2995C31.6295 29.05 31.9395 28.8 32.0095 28.46ZM21.9595 27.55L20.5595 21.58C22.4795 21.57 24.3995 21.58 26.3195 21.58C28.2295 21.58 30.1295 21.59 32.0395 21.58L30.6795 27.54H21.9595V27.55Z"
                                    fill="#FFFFFF" transform="scale(2.0) translate(-11 -14)" />
                            </svg>
                            <div>
                                直接購買
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { TaazeProductUrlCreator } from '@/utils/taazeProductUrlCreator';
import Product from '@/models/Product';
import { TaazeMediaUrlCreator } from '@/utils/taazeMediaUrlCreator';

const props = defineProps<{
    product: Product;
}>();

const taazeProductUrlCreator = new TaazeProductUrlCreator();
const taazeMediaUrlCreator = new TaazeMediaUrlCreator();

const productUrl = taazeProductUrlCreator.createProductUrl(props.product.id);
const addToCartUrl = taazeProductUrlCreator.createAddToCartUrl(props.product.id);
const productMediaUrl = taazeMediaUrlCreator.createProductImageUrl(props.product.id)
</script>

<style scoped>
.product-card {
    background-color: white;
}

.product-container {
    background-color: white;
}

.product-image {
    width: 80px;
    height: 115px;
    margin-right: 8px;
}

.product-data-container {
    width: 60%;
}

.product-title {
    font-family: 'Noto Sans';
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;

    white-space: nowrap;
    /* Prevent text from wrapping */
    overflow: hidden;
    /* Hide text that overflows */
    text-overflow: ellipsis;
    /* Display ellipsis when text overflows */
    display: block;
    /* Ensures title is a block element */
    margin-bottom: 8px;

    /* The following properties ensure it works with flexbox and handles truncation */
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-title a {
    color: black;
    text-decoration: none;
}

.product-price-data {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 8px;
}

.add-to-cart-button {
    background-color: #FF057D;
    width: 132px;
    border-radius: 36px;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    color: white;
}

.add-to-cart-button svg {
    width: 22px;
    /* Adjust the width as needed */
    height: 22px;
    /* Adjust the height as needed */
    margin-right: 2px;
    /* Add some margin if necessary */
}

.add-to-cart-button div {
    display: inline;
}

.add-to-cart-button:hover {
    background-color: #CC4173;
    color: white;
}
</style>